import { Environment } from '@thiememeulenhoff/types';

export interface LicenseInterface {
  product: {
    publisherInfo?: {
      description: string;
      value: string;
    };
  };
}

export interface ClaimsInterface {
  sub: string;
  first_name: string;
  tussenvoegsels?: string;
  family_name: string;
  licenses?: Array<LicenseInterface>;
}

export const ISSUERS = {
  [Environment.Development]: 'https://idp-test.toegang.org/oidc/',
  [Environment.Test]: 'https://idp-test.toegang.org/oidc/',
  [Environment.Acceptance]: 'https://idp-test.toegang.org/oidc/',
  [Environment.Staging]: 'https://idp.toegang.org/oidc/',
  [Environment.Production]: 'https://idp.toegang.org/oidc/',
};
